import React from 'react';
import './ErrorMessage.css';

/**
 * 에러 메시지를 표시하는 공통 컴포넌트
 * @param {string} message - 에러 메시지
 * @param {string} type - 메시지 타입 ('error', 'success', 'warning')
 * @param {Function} onClose - 닫기 버튼 클릭 핸들러
 * @param {boolean} showCloseButton - 닫기 버튼 표시 여부
 */
const ErrorMessage = ({ 
  message, 
  type = 'error', 
  onClose, 
  showCloseButton = true 
}) => {
  if (!message) return null;

  return (
    <div className={`error-message ${type}`}>
      <span className="message-text">{message}</span>
      {showCloseButton && onClose && (
        <button 
          className="close-button" 
          onClick={onClose}
          aria-label="메시지 닫기"
        >
          ×
        </button>
      )}
    </div>
  );
};

export default ErrorMessage;